import { render, staticRenderFns } from "./ExtruderMachineAdd.vue?vue&type=template&id=d087357a&"
import script from "./ExtruderMachineAdd.vue?vue&type=script&lang=js&"
export * from "./ExtruderMachineAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports